import { Dropdown, Input, Modal, Spin, Table } from "antd";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link, useNavigate } from "react-router-dom";
import toast from "react-hot-toast";
import svg27 from "../../../assets/svg/svg27.svg";
import svg70 from "../../../assets/svg/svg70.svg";
import svg69 from "../../../assets/svg/svg69.svg";
import svg167 from "../../../assets/svg/svg167.svg";
import DeleteModal from "../../../components/DeleteModal";
import svg2 from "../../../assets/svg/svg2.svg";
import AddSpaPaybillModal from "./modal/AddSpaPaybillModal";
import { fetchData } from "../../../features/fetch/fetchSlice";
import CardLoading from "../../../components/CardLoading";
import { deletePaybill } from "../../../features/delete-setting/deleteSlice";
import BreadCrumb from "../../../layout/BreadCrumb";
import SpaTransferModal from "./modal/SpaTransferModal";
import Search from "../../../components/Search";
import { numberWithCommas } from "../../../utils";
import BalanceModal from "./modal/BalanceModal";
import { save } from "../../../features/save/saveSlice";

export default function SpaPaybillTable() {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const url = "api/v1/active-paybill/get-spa-active-paybills";
  const urlInitiate = "api/v1/active-paybill/initiate-check-balance";
  const urlCheckBalance = "api/v1/active-paybill/get-balance";

  const { data, count, loading } = useSelector((state) => ({
    data: state.fetch.data[url] || [],
    count: state.fetch.count[url] || 0,
    loading: state.fetch.loading[url],
  }));

  const {saving} =  useSelector((state)=>state.save)

  const [searchInput, setSearchInput] = useState("");
  const handleSearch = (e) => {
    setSearchInput(e.target.value);
    dispatch(fetchData({ url, ["apbNumber"]: e.target.value || null }));
  };

  const [open, setopen] = useState(false);

  function handleCancel() {
    setopen(false);
  }

  const [openTransfer, setopenTransfer] = useState(false);
  function handleOpenTransfer() {
    setopenTransfer(true);
  }
  function handleCancelTransfer() {
    setopenTransfer(false);
  }
  const [prodd, setProdd] = useState("");
  const [prodd1, setProdd1] = useState("");

  const [openBalance, setopenBalance] = useState(false);
  const [checkingBalance, setCheckingBalance] = useState(false);

  async function handleOpenBalance() {
    setCheckingBalance(true);
    const res = await dispatch(
      save({
        url: urlInitiate,
        apbId: prodd?.apbId,
      })
    );
    if (res?.payload?.success) {
      const maxDuration = 90000; // 1.5 minutes in milliseconds
      const pollInterval = 5000; // 5 seconds in milliseconds
      const startTime = Date.now();

      const pollBalance = async () => {
        const res1 = await dispatch(
          save({
            url: urlCheckBalance,
            apbId: prodd?.apbId,
          })
        );

        if (res1?.payload?.success) {
          await setCheckingBalance(false);
          await setopenBalance(true);
          await setProdd1(res1?.payload?.data?.result);
          return true;
        } else {
          const elapsedTime = Date.now() - startTime;

          if (elapsedTime >= maxDuration) {
            await setCheckingBalance(false);
            toast.error(res1?.payload?.messages?.message || "Balance check timed out after 1.5 minutes");
            return true;
          }

          await new Promise(resolve => setTimeout(resolve, pollInterval));
          return await pollBalance();
        }
      };

      await pollBalance();
    } else {
      await setCheckingBalance(false);
      toast.error(res?.payload?.messages?.message);
    }
  }
  async function handleCancelBalance() {
    await setopenBalance(false);
    await fetchTableData();
  }

  const [isModalOpenDelete, setIsModalOpenDelete] = useState(false);
  const showModalDelete = async () => {
    setIsModalOpenDelete(true);
  };

  const handleDelete = async () => {
    const res = await dispatch(
      deletePaybill({
        apbId: prodd?.apbId,
      })
    );
    if (res?.payload?.success) {
      await toast.success(res?.payload?.messages?.message);
      await fetchTableData();
      await setIsModalOpenDelete(false);
    } else {
      toast.error(res?.payload?.messages?.message);
    }
  };

  const handleAdd = async () => {
    await setProdd("");
    await setopen(true);
  };

  const handleEdit = () => {
    setopen(true);
  };

  const settingItems = [
    {
      key: "1",
      label: (
        <Link
          onClick={handleEdit}
          className="flex gap-x-[.75rem] items-center py-[.5rem] font-dmSans"
        >
          <img src={svg69} alt="svg69" className="w-4 h-4" />
          <span className="whitespace-nowrap">Edit</span>
        </Link>
      ),
    },
    {
      key: "divider-1",
      type: "divider",
    },
    {
      key: "2",
      label: (
        <Link
          onClick={handleOpenTransfer}
          className="flex gap-x-[.75rem] items-center py-[.5rem] font-dmSans"
        >
          <img src={svg70} alt="svg70" className="w-4 h-4" />
          <span className="whitespace-nowrap">Transfer</span>
        </Link>
      ),
    },
    {
      key: "divider-2",
      type: "divider",
    },
    {
      key: "3",
      label: (
        <Link
          onClick={handleOpenBalance}
          className="flex gap-x-[.75rem] items-center py-[.5rem] font-dmSans"
        >
          <img src={svg167} alt="svg167" className="w-4 h-4" />
          <span className="whitespace-nowrap">Balance</span>
        </Link>
      ),
    },
    {
      key: "divider-3",
      type: "divider",
    },
  ];

  const columns = [
    {
      title: "Paybill Number",
      dataIndex: "apbNumber",
      sorter: (a, b) => a.apbNumber.localeCompare(b.apbNumber),
    },

    {
      title: "Type",
      dataIndex: "apbType",
      sorter: (a, b) => a.apbType.localeCompare(b.apbType),
    },
    {
      title: "User",
      dataIndex: "apbUser",
      sorter: (a, b) => a.apbUser.localeCompare(b.apbUser),
    },
    {
      title: "Utility Amount",
      dataIndex: "apbUtilityAmnt",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.apbUtilityAmnt.localeCompare(b.apbUtilityAmnt),
    },
    {
      title: "Working Amount",
      dataIndex: "apbWorkAmnt",
      render: (item) => {
        return <div>{numberWithCommas(item)}</div>;
      },
      sorter: (a, b) => a.apbWorkAmnt.localeCompare(b.apbWorkAmnt),
    },

    {
      title: "Description",
      dataIndex: "apbDesc",
      sorter: (a, b) => a.apbDesc.localeCompare(b.apbDesc),
    },
    {
      title: "Status",
      dataIndex: "apbStatus",
      render: (item) => {
        const colors = {
          ACTIVE: "#2DD683",
          REJECT: "#9D1500",
          INACTIVE: "#FFAB00",
        };

        return (
          <div
            className="text-[#FFF] inline-block rounded-[5px] px-2 py-1 w-auto"
            style={{
              backgroundColor: colors[item] || "darkGreen",
            }}
          >
            {item}
          </div>
        );
      },
    },

    {
      title: "Actions",
      render: (item) => (
        <>
          <Dropdown
            overlayStyle={{
              width: "250px",
            }}
            trigger={"click"}
            menu={{ items: settingItems }}
            placement="bottom"
          >
            <button onClick={() => setProdd(item)}>
              <img src={svg27} alt="svg27" />
            </button>
          </Dropdown>
        </>
      ),
    },
  ];

  const [pageIndex, setPageIndex] = useState(0);
  const [pageSize, setPageSize] = useState(10);

  async function fetchTableData(page, size) {
    await dispatch(
      fetchData({
        url: url,
        limit: size ?? pageSize,
        start: page ?? pageIndex,
      })
    );
  }

  useEffect(() => {
    fetchTableData();
  }, []);
  const breadList = [
    {
      title: (
        <div className="flex items-center gap-[.25rem]">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="14"
            viewBox="0 0 14 14"
            fill="none"
          >
            <g clipPath="url(#clip0_627_13942)">
              <path
                d="M13.7899 6.89067L7.75241 0.856289L7.34772 0.451602C7.25551 0.360003 7.13082 0.308594 7.00085 0.308594C6.87087 0.308594 6.74618 0.360003 6.65397 0.451602L0.211783 6.89067C0.117301 6.98478 0.0426296 7.09687 -0.00782254 7.22031C-0.0582747 7.34376 -0.0834854 7.47607 -0.0819665 7.60942C-0.0757165 8.15942 0.382096 8.59848 0.932096 8.59848H1.59616V13.6875H12.4055V8.59848H13.0837C13.3508 8.59848 13.6024 8.49379 13.7915 8.30473C13.8846 8.21193 13.9583 8.10159 14.0085 7.98009C14.0586 7.8586 14.0842 7.72836 14.0837 7.59692C14.0837 7.33129 13.979 7.07973 13.7899 6.89067ZM7.87585 12.5625H6.12585V9.37504H7.87585V12.5625ZM11.2805 7.47348V12.5625H8.87585V9.00004C8.87585 8.65473 8.59616 8.37504 8.25085 8.37504H5.75085C5.40553 8.37504 5.12585 8.65473 5.12585 9.00004V12.5625H2.72116V7.47348H1.22116L7.00241 1.69691L7.36335 2.05785L12.7821 7.47348H11.2805Z"
                fill="black"
                fillOpacity="0.45"
              />
            </g>
            <defs>
              <clipPath id="clip0_627_13942">
                <rect width="14" height="14" fill="white" />
              </clipPath>
            </defs>
          </svg>
          <span>Home</span>
        </div>
      ),
      href: "/#/home",
    },
    {
      title: <div className="text-lighGold text-[16px]">Paybill</div>,
    },
  ];

  if (loading  ) return <CardLoading />;
  return (
    <div className="w-full h-full overflow-y-scroll">
      <div className="justify-between items-center white_card">
        <BreadCrumb
          breadList={breadList}
          header={"SPA Paybill Information"}
          info={"Here’s an overview of your spa paybills"}
          btn={false}
          true
          btnTitle="Add Paybill"
          onClick={handleAdd}
          btnSvg={svg2}
        />
      </div>

      <div className="bg-white rounded-[10px] mt-[1.25rem] h-full">
        <div className="flex flex-col w-full lg:px-10 px-3 ">
          <div className="flex lg:flex-row flex-col lg:items-center justify-between  mt-[1.25rem]">
            <h3 className="heading_4">Spa Paybill Details</h3>
            <div className="lg:w-[16.125rem] w-full">
              <Search
                searchInput={searchInput}
                handleSearch={handleSearch}
                text="Search"
              />
            </div>
          </div>
          <div className="dash-inner-page mt-[24px] max-w-full w-full overflow-x-auto">
            <section>
              <Table
                rowSelection={false}
                className="mt-[1.31rem] w-full"
                scroll={{
                  x: 800,
                }}
                rowKey={(record) => record?.apbId}
                columns={columns}
                dataSource={data}
                loading={loading}
                pagination={{
                  position: ["bottomCenter"],
                  current: pageIndex + 1,
                  total: count,
                  pageSize: pageSize,
                  onChange: (page, size) => {
                    setPageIndex(page - 1);
                    setPageSize(size);
                    fetchTableData(page - 1, size);
                  },
                  showSizeChanger: false,
                  hideOnSinglePage: true,
                }}
              />
            </section>
          </div>
        </div>
      </div>

      <DeleteModal
        isModalOpen={isModalOpenDelete}
        setIsModalOpen={setIsModalOpenDelete}
        prodd={prodd}
        handleDelete={handleDelete}
        loading={loading}
        content={`Are you sure you want to delete Paybill  ${prodd?.pbPaybill} `}
        title={`Delete Paybill  ${prodd?.pbPaybill}`}
      />

      <AddSpaPaybillModal
        handleFetchData={fetchTableData}
        open={open}
        handleCancel={handleCancel}
        prodd={prodd}
      />

      <SpaTransferModal
        handleFetchData={fetchTableData}
        open={openTransfer}
        handleCancel={handleCancelTransfer}
        prodd={prodd}
      />

      <BalanceModal
        handleFetchData={fetchTableData}
        open={openBalance}
        handleCancel={handleCancelBalance}
        prodd={prodd}
        prodd1={prodd1}
      />

      <Modal
        open={checkingBalance}
        footer={null}
        closable={false}
        centered
        width={400}
      >
        <div className="flex flex-col items-center justify-center py-8">
          <Spin className="sms-spin" size="large" />
          <p className="mt-4 text-lg font-dmSans text-center">
            Checking Balance...
          </p>
          <p className="mt-2 text-sm text-gray-500 text-center">
            Please wait while we retrieve your balance information
          </p>
        </div>
      </Modal>
    </div>
  );
}
